const deepFreeze = <T extends object>(obj: T) => {
  Object.freeze(obj)

  Object.values(obj).forEach(value => {
    if (typeof value === 'object' && value !== null) {
      deepFreeze(value)
    }
  })

  return obj
}

export default deepFreeze
